import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API = 'https://app.recensement-enfantsnonproteges.fr';

const getEtat = (f) => {
  if (!f.etat_plainte) return null;
  if (f.etat_plainte.includes('Cassation') || f.etat_plainte.includes('CEDH')) return { label: 'Cassation', color: '#7c3aed', bg: '#f5f3ff' };
  if (f.etat_plainte.includes('Condamné') || f.etat_plainte.includes('Non-lieu') || f.etat_plainte.includes('Acquittement') || f.etat_plainte.includes('Relaxe')) return { label: 'Jugé', color: '#065f46', bg: '#d1fae5' };
  return { label: 'En cours', color: '#1e40af', bg: '#dbeafe' };
};

const getTags = (f) => {
  const tags = [];
  if (f.type_violences?.some(v => v.includes('Viol') || v.includes('Agression'))) tags.push({ label: 'VSS', color: '#fff', bg: '#1a7fd4' });
  if (f.type_violences?.some(v => v.includes('physique') || v.includes('Physique') || v.includes('coercitif') || v.includes('institutionnel'))) tags.push({ label: 'VP/P', color: '#fff', bg: '#1a7fd4' });
  if (f.alerte_urgence) tags.push({ label: 'DANGER IMMÉDIAT', color: '#fff', bg: '#e24b4a' });
  if (f.nb_condamnations_pp > 0) tags.push({ label: 'MAMAN CONDAMNÉE', color: '#fff', bg: '#1a7fd4' });
  if (f.enfants?.some(e => e.protege)) tags.push({ label: 'PROTÉGÉ.S', color: '#fff', bg: '#1a7fd4' });
  return tags;
};

const getTitre = (f) => {
  const nb = f.nb_enfants || (f.enfants?.length) || 1;
  const garde = f.garde_agresseur || '';
  if (garde.includes('alternée')) return `Procédure garde alternée ${nb} enfant${nb > 1 ? 's' : ''}.`;
  if (nb > 1) return `Procédure fratrie de ${nb} enfants.`;
  return `Procédure 1 enfant.`;
};

export default function PageFiches({ selectedFicheId, onClearFiche }) {
  const [fiches, setFiches] = useState([]);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    if (selectedFicheId && fiches.length > 0) {
      const f = fiches.find(f => f.id === selectedFicheId);
      if (f) { setSelected(f); onClearFiche && onClearFiche(); }
    }
  }, [selectedFicheId, fiches]);
  const [filtre, setFiltre] = useState('toutes');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/api/fiches`).then(r => { setFiches(r.data); setLoading(false); }).catch(() => setLoading(false));
  }, []);

  const fichesFiltrees = fiches.filter(f => {
    if (filtre === 'urgences') return f.alerte_urgence;
    if (filtre === 'vss') return f.type_violences?.some(v => v.includes('Viol') || v.includes('Agression'));
    if (filtre === 'physiques') return f.type_violences?.some(v => v.includes('physique') || v.includes('Physique'));
    if (filtre === 'condamnees') return f.nb_condamnations_pp > 0;
    if (filtre === 'proteges') return f.enfants?.some(e => e.protege);
    return true;
  });

  if (selected) return <FicheDetail fiche={selected} onBack={() => setSelected(null)} />;

  return (
    <div style={{maxWidth:'1100px',margin:'0 auto',padding:'36px 24px 60px'}}>
      <h2 style={{fontSize:'26px',fontWeight:'800',color:'#0a1f44',textTransform:'uppercase',marginBottom:'4px'}}>Fiches</h2>
      <div style={{fontSize:'13px',color:'#888',marginBottom:'20px'}}>Dernières fiches recensées</div>

      <div style={{display:'flex',gap:'8px',flexWrap:'wrap',marginBottom:'24px'}}>
        {[['toutes','Toutes'],['urgences','⚠ Urgences'],['vss','VSS'],['physiques','VP/P'],['condamnees','Maman condamnée'],['proteges','Protégé.s']].map(([v,l]) => (
          <button key={v} className={`chip${filtre===v?' on':''}`} onClick={() => setFiltre(v)}>{l}</button>
        ))}
      </div>

      {loading && <div style={{textAlign:'center',padding:'60px',color:'#888'}}>Chargement…</div>}

      {!loading && fichesFiltrees.length === 0 && (
        <div style={{textAlign:'center',padding:'60px',color:'#888'}}>Aucune fiche pour le moment.</div>
      )}

      <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:'16px'}}>
        {fichesFiltrees.map(f => {
          const etat = getEtat(f);
          const tags = getTags(f);
          const titre = getTitre(f);
          return (
            <div key={f.id} onClick={() => setSelected(f)}
              style={{background:'#fff',border:'1px solid #dde3f0',borderRadius:'12px',padding:'20px',cursor:'pointer'}}
              onMouseEnter={e=>e.currentTarget.style.boxShadow='0 4px 16px rgba(0,0,0,0.08)'}
              onMouseLeave={e=>e.currentTarget.style.boxShadow='none'}>
              <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:'10px'}}>
                <span style={{fontSize:'11px',color:'#aaa'}}>{new Date(f.created_at).toLocaleDateString('fr-FR')}</span>
                {etat && <span style={{fontSize:'11px',padding:'2px 8px',borderRadius:'4px',fontWeight:'600',background:etat.bg,color:etat.color}}>{etat.label}</span>}
              </div>
              <div style={{display:'flex',gap:'6px',flexWrap:'wrap',marginBottom:'14px'}}>
                {tags.map((t,i) => <span key={i} style={{fontSize:'10px',padding:'3px 10px',borderRadius:'999px',fontWeight:'700',background:t.bg,color:t.color}}>{t.label}</span>)}
              </div>
              <div style={{fontSize:'15px',fontWeight:'700',color:'#0a1f44',lineHeight:'1.35'}}>{titre}</div>
              {f.departement && <div style={{fontSize:'11px',color:'#aaa',marginTop:'8px'}}>{f.departement}</div>}
            </div>
          );
        })}
      </div>
    </div>
  );
}

function FicheDetail({ fiche: f, onBack }) {
  const tags = getTags(f);
  const etat = getEtat(f);

  return (
    <div style={{maxWidth:'720px',margin:'0 auto',padding:'36px 24px 60px'}}>
      <span style={{fontSize:'12px',color:'#888',cursor:'pointer',marginBottom:'24px',display:'inline-block'}} onClick={onBack}>← Retour aux fiches</span>

      <div style={{background:'#0a1f44',borderRadius:'16px',padding:'28px',marginBottom:'24px'}}>
        <div style={{display:'flex',gap:'8px',flexWrap:'wrap',marginBottom:'16px'}}>
          {tags.map((t,i) => <span key={i} style={{fontSize:'11px',padding:'4px 12px',borderRadius:'999px',fontWeight:'700',background:t.bg==='#e24b4a'?'#e24b4a':'rgba(255,255,255,0.15)',color:'#fff'}}>{t.label}</span>)}
          {etat && <span style={{fontSize:'11px',padding:'4px 12px',borderRadius:'999px',fontWeight:'700',background:'rgba(255,255,255,0.15)',color:'#fff'}}>{etat.label}</span>}
        </div>
        <h1 style={{fontSize:'22px',fontWeight:'800',color:'#fff',marginBottom:'8px'}}>{getTitre(f)}</h1>
        <div style={{fontSize:'13px',color:'rgba(255,255,255,0.6)'}}>
          {f.departement && `${f.departement} · `}
          {f.tribunal && `JAF ${f.tribunal} · `}
          {new Date(f.created_at).toLocaleDateString('fr-FR')}
        </div>
      </div>

      {f.temoignage && (
        <div style={{background:'#fff',borderRadius:'12px',padding:'20px',marginBottom:'16px',border:'1px solid #dde3f0'}}>
          <div style={{fontSize:'11px',fontWeight:'700',color:'#1a7fd4',textTransform:'uppercase',letterSpacing:'0.06em',marginBottom:'12px'}}>Témoignage</div>
          <p style={{fontSize:'14px',color:'#333',lineHeight:'1.75',fontStyle:'italic'}}>« {f.temoignage} »</p>
        </div>
      )}

      <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'12px',marginBottom:'16px'}}>
        {f.garde_agresseur && (
          <div style={{background:'#fef2f2',borderRadius:'10px',padding:'14px',border:'1px solid #fecaca'}}>
            <div style={{fontSize:'10px',color:'#991b1b',fontWeight:'700',textTransform:'uppercase',marginBottom:'6px'}}>Garde agresseur</div>
            <div style={{fontSize:'14px',fontWeight:'700',color:'#7f1d1d'}}>{f.garde_agresseur}</div>
          </div>
        )}
        {f.garde_pp && (
          <div style={{background:'#f0f7ff',borderRadius:'10px',padding:'14px',border:'1px solid #b5d4f4'}}>
            <div style={{fontSize:'10px',color:'#185fa5',fontWeight:'700',textTransform:'uppercase',marginBottom:'6px'}}>Garde parent protecteur</div>
            <div style={{fontSize:'14px',fontWeight:'700',color:'#0a1f44'}}>{f.garde_pp}</div>
          </div>
        )}
        {f.etat_plainte && (
          <div style={{background:'#f4f6fb',borderRadius:'10px',padding:'14px',border:'1px solid #dde3f0'}}>
            <div style={{fontSize:'10px',color:'#666',fontWeight:'700',textTransform:'uppercase',marginBottom:'6px'}}>État de la plainte</div>
            <div style={{fontSize:'14px',fontWeight:'700',color:'#0a1f44'}}>{f.etat_plainte}</div>
          </div>
        )}
        {f.raison_invoquee && (
          <div style={{background:'#f4f6fb',borderRadius:'10px',padding:'14px',border:'1px solid #dde3f0'}}>
            <div style={{fontSize:'10px',color:'#666',fontWeight:'700',textTransform:'uppercase',marginBottom:'6px'}}>Raison invoquée</div>
            <div style={{fontSize:'14px',fontWeight:'700',color:'#0a1f44'}}>{f.raison_invoquee}</div>
          </div>
        )}
      </div>

      {(f.cout_financier || f.cout_medical || f.cout_professionnel) && (
        <div style={{background:'#fff',borderRadius:'12px',padding:'20px',marginBottom:'16px',border:'1px solid #dde3f0'}}>
          <div style={{fontSize:'11px',fontWeight:'700',color:'#1a7fd4',textTransform:'uppercase',letterSpacing:'0.06em',marginBottom:'12px'}}>Coûts</div>
          <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:'12px'}}>
            {f.cout_financier && <div style={{textAlign:'center'}}><div style={{fontSize:'18px',fontWeight:'800',color:'#0a1f44'}}>{Number(f.cout_financier).toLocaleString('fr-FR')} €</div><div style={{fontSize:'11px',color:'#888'}}>Juridique</div></div>}
            {f.cout_medical && <div style={{textAlign:'center'}}><div style={{fontSize:'18px',fontWeight:'800',color:'#0a1f44'}}>{Number(f.cout_medical).toLocaleString('fr-FR')} €</div><div style={{fontSize:'11px',color:'#888'}}>Médical</div></div>}
            {f.cout_professionnel && <div style={{textAlign:'center'}}><div style={{fontSize:'18px',fontWeight:'800',color:'#0a1f44'}}>{Number(f.cout_professionnel).toLocaleString('fr-FR')} €</div><div style={{fontSize:'11px',color:'#888'}}>Professionnel</div></div>}
          </div>
        </div>
      )}

      {(f.nb_preuves || f.nb_magistrats || f.nb_jugements || f.nb_dysfonctionnements || f.nb_dossier_perdu || f.nb_enfant_a_parle) && (
        <div style={{background:'#e6f1fb',borderRadius:'12px',padding:'20px',border:'1px solid #b5d4f4'}}>
          <div style={{fontSize:'11px',fontWeight:'700',color:'#185fa5',textTransform:'uppercase',letterSpacing:'0.06em',marginBottom:'12px'}}>Données institutionnelles</div>
          <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:'12px'}}>
            {f.nb_preuves>0&&<div style={{textAlign:'center'}}><div style={{fontSize:'22px',fontWeight:'800',color:'#1a7fd4'}}>{f.nb_preuves}</div><div style={{fontSize:'11px',color:'#555'}}>Preuves</div></div>}
            {f.nb_magistrats>0&&<div style={{textAlign:'center'}}><div style={{fontSize:'22px',fontWeight:'800',color:'#1a7fd4'}}>{f.nb_magistrats}</div><div style={{fontSize:'11px',color:'#555'}}>Magistrats</div></div>}
            {f.nb_jugements>0&&<div style={{textAlign:'center'}}><div style={{fontSize:'22px',fontWeight:'800',color:'#1a7fd4'}}>{f.nb_jugements}</div><div style={{fontSize:'11px',color:'#555'}}>Jugements</div></div>}
            {f.nb_dysfonctionnements>0&&<div style={{textAlign:'center'}}><div style={{fontSize:'22px',fontWeight:'800',color:'#1a7fd4'}}>{f.nb_dysfonctionnements}</div><div style={{fontSize:'11px',color:'#555'}}>Dysfonct.</div></div>}
            {f.nb_dossier_perdu>0&&<div style={{textAlign:'center'}}><div style={{fontSize:'22px',fontWeight:'800',color:'#1a7fd4'}}>{f.nb_dossier_perdu}</div><div style={{fontSize:'11px',color:'#555'}}>Dossier perdu</div></div>}
            {f.nb_enfant_a_parle>0&&<div style={{textAlign:'center'}}><div style={{fontSize:'22px',fontWeight:'800',color:'#1a7fd4'}}>{f.nb_enfant_a_parle}</div><div style={{fontSize:'11px',color:'#555'}}>Enfant a parlé</div></div>}
          </div>
        </div>
      )}

      {f.type_violences?.length > 0 && (
        <div style={{marginTop:'16px',display:'flex',gap:'8px',flexWrap:'wrap'}}>
          {f.type_violences.map(v => <span key={v} style={{fontSize:'11px',padding:'4px 12px',borderRadius:'999px',background:'#e6f1fb',color:'#1a7fd4',fontWeight:'600'}}>{v}</span>)}
        </div>
      )}
    </div>
  );
}
